/**
 * Los dos botones de la landing del vídeo, con la voz de los CTAs de la home
 * (`santa-home.tsx` → `HeroSection`): píldora, festiva y grande. La landing es
 * una página de marketing, así que sigue la variante de landing de DESIGN.md
 * §3 (CTAs festivos); el wizard `/crear` y la entrega, no.
 *
 * Un único primario en toda la página —todos llevan a `/crear`— para que el
 * embudo tenga una sola acción reconocible.
 */
const BASE =
  'font-christmas inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-8 py-4 text-xl font-bold shadow-2xl transition-transform hover:scale-105 active:scale-95 focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-amber-200/80 motion-reduce:transition-none motion-reduce:hover:scale-100'

export const LANDING_CTA = `${BASE} bg-secondary text-secondary-foreground`

export const LANDING_CTA_OUTLINE = `${BASE} border border-white/60 bg-white/10 text-white backdrop-blur hover:bg-white/20`
